<template>
    <div ref="profile" class="profile bg-white">
        <div class="profile__content min-h-screen mt-42 md:mt-100 mb-24 md:mb-0">
            <template v-if="profile && profile.profileBody">
                <div v-for="(element, index) in profile.profileBody" :key="'svg' + index" class="profile__element flex flex-col justify-center items-start md:items-center md:mb-42">
                    <intersect @enter.once="introAnim">
                        <div class="relative h-64 md:h-auto w-full md:w-auto overflow-hidden">
                            <svg xmlns="http://www.w3.org/2000/svg" :style="'width :' + element.profileBlockText[0].titleWidth" height="357" class="profile__element mx-auto">
                                <clipPath :id="'clip' + index" v-html="element.profileBlockText[0].titleSvg"></clipPath>
                                <image class="block mx-auto" :xlink:href="element.profileBlockText[0].backgroundImage[0].url" :width="element.profileBlockText[0].backgroundImage[0].width" :height="element.profileBlockText[0].backgroundImage[0].height" :style="'-webkit-clip-path: url('+ pageUrl +'#numberClip); clip-path: url(#clip'+ index +' );'" />
<!--                                <image :xlink:href="image[0].url" :width="image[0].width" :height="image[0].height" :style="'filter:url(#distortionFilter); -webkit-clip-path: url('+ pageUrl +'#numberClip); clip-path: url('+ pageUrl +'#numberClip); '"/>-->
                            </svg>
                        </div>
                    </intersect>
                    <p class="max-w-md mx-auto md:mt-42 px-10 md:px-0 font-codesaver-regular text-base md:text-2xl text-justify leading-normal" :key="'text'+index" v-html="element.profileBlockText[0].contentText.content"></p>
                </div>
            </template>
        </div>
        <div class="profile__footer bg-black text-center pb-16 md:pb-24">
            <div class="profile__social pt-16 md:pt-0 h-auto md:h-48 flex flex-col md:flex-row justify-center items-center">
                <a class="font-signal-regular text-white text-sm md:text-2xl leading-normal tracking-extrawide uppercase no-underline" v-if="profile && profile.profileInstragramDesignus" :href="profile.profileInstragramDesignus[0].customUrl" target="_blank">{{ profile.profileInstragramDesignus[0].displayText }}</a>
                <a class="font-signal-regular text-white text-sm md:text-2xl leading-normal tracking-extrawide uppercase no-underline" v-if="profile && profile.profileInstagramSennesro" :href="profile.profileInstagramSennesro[0].customUrl" target="_blank">{{ profile.profileInstagramSennesro[0].displayText }}</a>
                <a class="font-signal-regular text-white text-sm md:text-2xl leading-normal tracking-extrawide uppercase no-underline" v-if="profile && profile.profileLinkedin" :href="profile.profileLinkedin[0].customUrl" target="_blank">{{ profile.profileLinkedin[0].displaytext }}</a>
            </div>
            <div v-if="profile && profile.profileAvailability[0].available" class="profile__availability flex justify-center items-center h-32">
                <a :href="'mailto:'+profile.profileAvailability[0].availabilitymail" class="profile__underline font-signal-regular text-white text-2xl md:text-2-5xl tracking-extrawide uppercase no-underline">{{ profile.profileAvailability[0].availabilitytext }}</a>
            </div>
        </div>
    </div>
</template>

<script>
    import gql from 'graphql-tag';
    import { TweenMax, Power3 } from 'gsap';
    import { mapMutations } from 'vuex';
    import Intersect from "vue-intersect";

    export default {

        components: { Intersect },

        apollo : {
            profile : gql`query{
              profile : entry(title:"Profile"){
                ... on Profile {
                  profileInstragramDesignus {
                    displayText
                    customUrl
                  }
                  profileInstagramSennesro{
                    displayText
                    customUrl
                  }
                  profileLinkedin{
                    displaytext
                    customUrl
                  }
                  profileAvailability{
                    available
                    availabilitytext
                    availabilitymail
                  }
                  profileBody {
                    ... on ProfileBodyBlockText {
                      profileBlockText {
                        titleSvg
                        titleWidth
                        backgroundImage {
                          url
                          width
                          height
                        }
                        contentText {
                          content
                        }
                      }
                    }
                  }
                }
              }
            }`
        },

        computed : {
            pageUrl(){
                return window.location.href + '/profile';
            }
        },

        metaInfo: {
            title: 'About us'
        },

        mounted(){
            this.$store.commit('updateHeaderColor', 'black');

            window.addEventListener('resize', this.resizeHandler);
            this.resizeHandler();
        },

        beforeDestroy(){
            window.removeEventListener('resize', this.resizeHandler);
        },

        methods : {
            resizeHandler() {
                TweenMax.set(document.querySelectorAll('.profile svg'), {
                    scale: (window.innerWidth < 768) ? 0.3 : 1,
                    position : (window.innerWidth < 768) ? 'absolute' : 'relative',
                    top : (window.innerWidth < 768) ? '50%' : 'inherit',
                    y : (window.innerWidth < 768) ? '-50%' : '0%',
                    left : (window.innerWidth < 768) ? '50%' : 'inherit',
                    x : (window.innerWidth < 768) ? '-50%' : '0%',
                });
            },

            introAnim(pIntersect){
                this.resizeHandler();

                var width = pIntersect[0].target.querySelector('svg').clientWidth;

                TweenMax.fromTo(pIntersect[0].target, 1, {
                    x : - width /2
                },{
                    x : 0,
                    ease : Power3.easeOut,
                    force3D : true
                });

                TweenMax.fromTo(pIntersect[0].target.querySelector('svg'), 1, {
                    width : 0,
                },{
                    width : width,
                    ease : Power3.easeOut,
                    force3D : true
                });
            },

            enterAnim(){
                console.log('hello enter');
                TweenMax.fromTo(document.querySelector('.profile'), 0.5, {
                    y : '100%',
                }, {
                    y : '0%'
                });
            },

            ...mapMutations(['updateHeaderColor'])
        }
    }
</script>

<style lang="scss">
    .profile {
        &__social a:not(:last-child)::after{
            @media (min-width : 768px) {
                content : '-';
                margin : 0 20px
            }
        }

        &__underline {
            position : relative;

            @media (min-width : 768px) {
                &::after {
                    content : '';
                    width: calc(100% - 10px);
                    height: 2px;
                    position: absolute;
                    bottom: -4px;
                    left: 3px;
                    background-color : white;
                }
            }
        }
    }
</style>